import { render, staticRenderFns } from "./HeaderSimple.vue?vue&type=template&id=ddeecd02&scoped=true"
import script from "./HeaderSimple.vue?vue&type=script&lang=js"
export * from "./HeaderSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeecd02",
  null
  
)

export default component.exports